import { Component, Input, OnDestroy, ViewEncapsulation } from '@angular/core';
import {
  MatLegacyDialog as MatDialog,
  MatLegacyDialogModule as MatDialogModule,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { MatLegacySnackBarModule, MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import {
  CadModelMaterialType,
  CadModelMaterialsMatchingModule,
  CuttingCadModelMaterialLink,
  CuttingProduct,
} from 'cloud-shared-lib';
import * as _ from 'lodash';
import { Subject } from 'rxjs';

import { NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatToolbarModule } from '@angular/material/toolbar';

@Component({
  templateUrl: './product-materials-link-dialog.component.html',
  styleUrls: ['./product-materials-link-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    MatToolbarModule,
    MatDialogModule,
    MatIconModule,
    FormsModule,
    MatTabsModule,
    MatDividerModule,
    CadModelMaterialsMatchingModule,
    NgIf,
    MatButtonModule,
    MatTooltipModule,
    MatLegacySnackBarModule,
  ],
})
export class ProductMaterialsLinkDialogComponent implements OnDestroy {
  matGroupingCheckbox = false;
  unsubscribe$: Subject<void> = new Subject();

  product: CuttingProduct[] = [];
  @Input() set products(val: CuttingProduct[]) {
    this.product = _.cloneDeep(val);
  }
  get products(): CuttingProduct[] {
    return this.product;
  }

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ProductMaterialsLinkDialogComponent>,
    private snackBar: MatSnackBar
  ) {}

  public saveAndClose(): void {
    for (const model of this.products) {
      if (
        model.parsedMaterials.findIndex(
          sb => sb.materialType === CadModelMaterialType.Side && _.isEmpty(sb.linkedMaterialName)
        ) !== -1
      ) {
        this.snackBar.open($localize`Назначьте соответствия облицовочному материалу`);
        return;
      }

      if (
        model.parsedMaterials.findIndex(
          sb => sb.materialType === CadModelMaterialType.Slot && _.isEmpty(sb.linkedMaterialName)
        ) !== -1
      ) {
        this.snackBar.open($localize`Назначьте соответствия пазам`);
        return;
      }

      if (
        model.parsedMaterials.findIndex(
          sb =>
            _.isEmpty(sb.linkedMaterialName) &&
            (sb.materialType === CadModelMaterialType.Plate || sb.materialType === CadModelMaterialType.Linear)
        ) !== -1
      ) {
        this.snackBar.open($localize`Выберите материалы для раскроя`);
        return;
      }
    }

    this.dialogRef.close(this.products);
    return;
  }

  getCommonMaterialLinks(models: CuttingProduct[]): CuttingCadModelMaterialLink[] {
    return _.flatMap(models, m => m.parsedMaterials as CuttingCadModelMaterialLink[]);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
  }
}
